export default __webpack_public_path__ + "assets/fonts/Inter-Medium.woff2";